(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cr-golden-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cr-golden-carousel')) {
  customElements.define('cr-golden-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.chapters = [...this.querySelectorAll('[data-go]')];
      this.index = 0;
      this.delay = Number(this.dataset.interval) || 5000;
      this.style.setProperty('--cr-duration', `${this.delay}ms`);
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true';
      this.focused = false;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-prev]').addEventListener('click', () => this.go(this.index - 1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.go(this.index + 1, true), options);
      this.chapters.forEach((button, index) => button.addEventListener('click', () => this.go(index, true), options));
      this.querySelector('[data-pause]').addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, options);
      this.addEventListener('focusin', event => { this.focused = event.target.matches(':focus-visible'); this.sync(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); } }, options);
      document.addEventListener('visibilitychange', () => this.sync(), options);
      this.reducedMotion.addEventListener('change', () => this.sync(), options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + (event.key === 'ArrowLeft' ? -1 : 1), true); }
      }, options);
      const viewport = this.querySelector('.cr-golden__viewport');
      viewport.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') this.touch = { x: event.clientX, y: event.clientY }; }, options);
      viewport.addEventListener('pointerup', event => {
        if (!this.touch) return;
        const dx = event.clientX - this.touch.x, dy = event.clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) { this.suppressClick = true; this.go(this.index + (dx < 0 ? 1 : -1), true); setTimeout(() => { this.suppressClick = false; }, 350); }
      }, options);
      viewport.addEventListener('pointercancel', () => { this.touch = null; }, options);
      viewport.addEventListener('click', event => { if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; } }, options);
      document.addEventListener('shopify:block:select', event => { const selected = this.slides.findIndex(slide => slide.dataset.shopifyEditorBlock?.includes(event.detail.blockId)); if (selected >= 0) { this.paused = true; this.go(selected, false); } }, options);
      this.sync();
    }
    go(index, announce) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, current) => { const active = current === this.index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.inert = !active; });
      this.chapters.forEach((chapter, current) => { chapter.classList.toggle('is-active', current === this.index); chapter.setAttribute('aria-current', String(current === this.index)); });
      if (announce) this.querySelector('[role="status"]').textContent = this.chapters[this.index].getAttribute('aria-label');
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      this.classList.remove('is-running');
      this.querySelector('[data-pause]').setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.querySelector('[data-pause-icon]').textContent = this.paused ? '▶' : 'Ⅱ';
      if (!this.paused && !this.focused && !document.hidden && this.slides.length > 1) {
        void this.offsetWidth;
        this.classList.add('is-running');
        this.timer = setTimeout(() => this.go(this.index + 1, false), this.delay);
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
